import i18n from '../../locales/index'
import CommonIcon from './common-icon.vue'
export default CommonIcon
